/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Button, Row, Spin } from "antd";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

import { SHORTCUT_FILTER } from "constants/volSurface";
import { storeInLocalStorage } from "helpers/Pricer/Table";
import React, { useContext, useEffect } from "react";
import { Sticky_Delta_Strike_LABELS } from "constants/generalActionButtons";
import { VolSurfaceContext } from "contexts/VolSurfaceContext";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { useQueryClient } from "@tanstack/react-query";
import { SURFACES_QUERY_KEY } from "constants/queries";
import { isDataMember, isTrader } from "helpers/generalHelper";

export default function Shortcuts({
  dark_Theme,
  currentTab,
  selectedFilters,
  setSelectedFilters,
  handleShortcutChange,
  setComparisonSurfaceId,
}) {
  const queryClient = useQueryClient();

  const { setRiskFree, setCostOfCarry, setAverage } =
    useVolSurfaceControlTable();
  const location = useLocation();
  const pathName = location.pathname;
  const isSticky = currentTab === Sticky_Delta_Strike_LABELS.STICKY_STRIKE.key;
  const {
    state: { volSurfaceFilterShortcuts, isShortcutsLoading },
  } = useContext(VolSurfaceContext);

  function changeCallback(item) {
    storeInLocalStorage("checkPopup", JSON.stringify(true));
    storeInLocalStorage(
      SHORTCUT_FILTER,
      JSON.stringify(item?.product_contract_style_id)
    );
    storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(false));
    storeInLocalStorage("IsRiskFreeChanged", JSON.stringify(false));
    storeInLocalStorage(
      "AverageAndCostOfCarryIsReloaded",
      JSON.stringify(true)
    );
    storeInLocalStorage("IsComparisonSurfaceChanged", JSON.stringify(false));
    storeInLocalStorage("IsRiskFreeChanged", JSON.stringify(false));
    storeInLocalStorage(
      "AverageAndCostOfCarryIsReloaded",
      JSON.stringify(true)
    );
  }

  function onClickHandle(item) {
    if (item.product_contract_style_id === selectedFilters["shortcutFilter"])
      return;
    queryClient.invalidateQueries({
      queryKey: [SURFACES_QUERY_KEY, item.product_contract_style_id],
    });
    setSelectedFilters((prev) => ({
      ...prev,
      product_id: item.product_contract_style_id,
      shortcutFilter: item.product_contract_style_id,
      comparison_surface_id: null,
      live_surface_id: null,
      risk_free: null,
      average: null,
      cost_of_carry: null,
      shortcut_name: item.label,
    }));
    setRiskFree(null);
    setAverage(null);
    setCostOfCarry(null);
    changeCallback(item);
    handleShortcutChange(item.product_contract_style_id);
    setComparisonSurfaceId(null);
  }

  useEffect(() => {
    if (isTrader() || isDataMember() || pathName.includes("vol-surface-data")) {
      const shortcut = localStorage.getItem(SHORTCUT_FILTER);
      const decodedShortcut =
        shortcut !== "null" && shortcut !== "undefined"
          ? JSON.parse(shortcut)
          : null;
      setSelectedFilters((prev) => ({
        ...prev,
        shortcutFilter: decodedShortcut
          ? decodedShortcut
          : volSurfaceFilterShortcuts?.at(0)?.product_contract_style_id,
        product_id:
          prev?.product_id ||
          volSurfaceFilterShortcuts
            ?.at(0)
            ?.product_contract_style_id.toString(),
      }));
      changeCallback(volSurfaceFilterShortcuts?.at(0));
    }
  }, [pathName, setSelectedFilters, volSurfaceFilterShortcuts]);

  useEffect(() => {
    if (
      isSticky &&
      !(isTrader() || isDataMember() || pathName.includes("vol-surface-data"))
    ) {
      setSelectedFilters((prev) => ({
        ...prev,
        shortcut_name: volSurfaceFilterShortcuts?.at(0)?.label,
        shortcutFilter:
          volSurfaceFilterShortcuts?.at(0)?.product_contract_style_id,
        product_id: volSurfaceFilterShortcuts
          ?.at(0)
          ?.product_contract_style_id.toString(),
      }));
      changeCallback(volSurfaceFilterShortcuts?.at(0));
    }
  }, [isSticky, pathName]);

  return (
    <Col span={24}>
      <Row className="bias-btn">
        <Col span={3}>Shortcuts:</Col>
        <Col span={21}>
          <Row gutter={12} style={{ rowGap: "12px" }}>
            {isShortcutsLoading || !volSurfaceFilterShortcuts ? (
              <Spin size="medium" className="mx-4" />
            ) : (
              <>
                {volSurfaceFilterShortcuts?.map((item) => {
                  return (
                    <Col key={item.label}>
                      <Button
                        className={classNames({
                          "ant-btn-dark": dark_Theme,
                          "selected-button":
                            item?.product_contract_style_id ===
                            selectedFilters["shortcutFilter"],
                        })}
                        key={item.label}
                        onClick={() => onClickHandle(item)}
                      >
                        {item.label}
                      </Button>
                    </Col>
                  );
                })}
              </>
            )}
          </Row>
        </Col>
      </Row>
    </Col>
  );
}
